import { createAction, props } from '@ngrx/store';
import { Notification, UnreadHorseNotification } from '@sleipai/sleip-models';

// single recording notification: read

export const watchActiveRecordingNotification = createAction(
  '[Notifications] Watch Active Recording Notification',
  props<{ recordingId: string; userId: string }>()
);

export const watchActiveRecordingNotificationSuccess = createAction(
  '[Notifications] Watch Active Recording Notification Success',
  props<{ recordingId: string; notification: Notification | null }>()
);

export const watchActiveRecordingNotificationFailure = createAction(
  '[Notifications] Watch Active Recording Notification Failure',
  props<{ error: any }>()
);

export const stopWatchingActiveRecordingNotification = createAction(
  '[Notifications] Stop Watching Active Recording Notification'
);

// single recording notification: write

export const markRecordingNotificationRead = createAction(
  '[Notifications] Mark Recording Notification Read',
  props<{
    recordingId: string;
    userId: string;
    read?: boolean;
  }>()
);

export const markRecordingNotificationReadSuccess = createAction(
  '[Notifications] Mark Recording Notification Read Success',
  props<{ recordingId: string; userId: string; read?: boolean }>()
);

export const markRecordingNotificationReadFailure = createAction(
  '[Notifications] Mark Recording Notification Read Failure',
  props<{ recordingId: string; read?: boolean; error: any }>()
);

// per-horse unread recordings: read

export const watchNotificationsForRecordingsUnread = createAction(
  '[Notifications] Watch Notifications For Recordings Unread',
  props<{ recordingIds: string[]; userId: string }>()
);

export const watchNotificationsForRecordingsUnreadSuccess = createAction(
  '[Notifications] Watch Notifications For Recordings Unread Success',
  props<{ recordingIds: string[]; notifications: Notification[] }>()
);

export const watchNotificationsForRecordingsUnreadFailure = createAction(
  '[Notifications] Watch Notifications For Recordings Unread Failure',
  props<{ error: any }>()
);

export const stopWatchingNotificationsForRecordingsUnread = createAction(
  '[Notifications] Stop Watching Notifications For Recordings Unread'
);

// per-horse unread recording counts: read

export const watchUnreadNotificationCountsByHorse = createAction(
  '[Notifications] Watch Unread Notification Counts By Horse',
  props<{ horseIds: string[]; userId: string }>()
);

export const watchUnreadNotificationCountsByHorseSuccess = createAction(
  '[Notifications] Watch Unread Notification Counts By Horse Success',
  props<{
    horseIds: string[];
    unreadNotificationCountsByHorse: UnreadHorseNotification[];
  }>()
);

export const watchUnreadNotificationCountsByHorseFailure = createAction(
  '[Notifications] Watch Unread Notification Counts By Horse Failure',
  props<{ error: any }>()
);

export const stopWatchingUnreadNotificationCountsByHorse = createAction(
  '[Notifications] Stop Watching Unread Notification Counts By Horse'
);

export const clearNotificationsError = createAction(
  '[Notifications] Clear Notifications Error'
);
